/* global Modernizr */

import { Controller } from 'stimulus';

const isLargeDisplay = () => Modernizr.mq('(min-width: 992px)');

const BASE_HEIGHT = '39px';

class FilterController extends Controller {
  connect() {
    if (!this.hasTogglerTarget) return;

    this.expanded = false;
    this.onWindowResize();

    window.addEventListener('resize', this.onWindowResize.bind(this));
  }

  disconnect() {
    window.removeEventListener('resize', this.onWindowResize.bind(this));
  }

  onTogglerClick() {
    this.expanded = !this.expanded;

    this.changeTogglerText();
    this.setCollapseHeight(this.expanded ? 'auto' : BASE_HEIGHT);
  }

  onWindowResize() {
    if (!isLargeDisplay()) return;

    this.setCollapseHeight(BASE_HEIGHT);
  }

  setCollapseHeight(height) {
    this.collapseTarget.style.height = height;
  }

  changeTogglerText() {
    const expandedText = this.togglerTarget.getAttribute('data-expanded-text');
    const collapsedText = this.togglerTarget.getAttribute('data-collapsed-text');

    this.togglerTarget.innerText = this.expanded ? collapsedText : expandedText;
  }
}

FilterController.targets = [
  'toggler',
  'collapse',
];

export default FilterController;
